import { createContext, useContext, useState, useEffect } from "react";
import { settingsAPI } from "../api";

const SettingsContext = createContext(null);

// Defaults en cliente (por si la petición falla)
const DEFAULTS = {
  site_name: "InmobiliariaPlus",
  site_tagline: "Tu aliado de confianza en bienes raíces",
  site_description: "",
  logo_url: "",
  favicon_url: "",
  color_primary: "#1B2B4B",
  color_accent: "#C9A96E",
  contact_address: "Calle Principal #123",
  contact_address_2: "Col. Centro, Córdoba, Ver.",
  contact_phone: "(271) 123-4567",
  contact_email: "contacto@inmobiliariaplus.mx",
  contact_hours_weekdays: "Lunes a Viernes: 9:00 – 18:00",
  contact_hours_saturday: "Sábados: 9:00 – 14:00",
  contact_hours_sunday: "",
  contact_lat: "18.886840",
  contact_lng: "-96.938591",
  contact_map_zoom: "15",
  whatsapp_number: "5212711234567",
  whatsapp_message: "Hola, me interesa obtener información sobre sus propiedades.",
  whatsapp_visible: "true",
  social_facebook: "",
  social_instagram: "",
  social_tiktok: "",
  social_youtube: "",
  social_twitter: "",
  hero_image_url: "",
  hero_title: "Encuentra tu\npropiedad ideal",
  hero_subtitle: "Casas, departamentos, ranchos y más. Asesoría personalizada sin compromiso.",
  hero_cta: "Buscar propiedades",
  seo_description: "",
  seo_keywords: "",
  ga_id: "",
  fb_pixel: "",
};

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

function aplicarColores(s) {
  const root = document.documentElement;
  if (s.color_primary) root.style.setProperty("--color-primary", s.color_primary);
  if (s.color_accent)  root.style.setProperty("--color-accent",  s.color_accent);
}

function aplicarFavicon(url) {
  if (!url) return;
  const href = url.startsWith("http") ? url : `${API_URL}${url}`;
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = href;
}

function aplicarTitulo(nombre) {
  if (nombre) document.title = nombre;
}

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    settingsAPI.publicas()
        .then((r) => {
          const merged = { ...DEFAULTS, ...r.data.data };
          setSettings(merged);
          aplicarColores(merged);
          aplicarFavicon(merged.favicon_url);
          aplicarTitulo(merged.site_name);
        })
        .catch(() => aplicarColores(DEFAULTS))
        .finally(() => setCargando(false));
  }, []);

  return (
      <SettingsContext.Provider value={{ settings, cargando, setSettings }}>
        {children}
      </SettingsContext.Provider>
  );
}

export function useSettings() {
  const ctx = useContext(SettingsContext);
  if (!ctx) throw new Error("useSettings debe usarse dentro de SettingsProvider");
  return ctx;
}
